import { useEffect } from "react";

import { analyticsService } from "../../lib/analytics";
import type { EventTypes } from "../../lib/analytics/types";
import type { CoveragePlan } from "./read/readCoverage";
import { headlineState } from "./root/HeadlineCard";

type Viewed = EventTypes["CoverageScreenViewed"];

/** One view event per Coverage sub-page once its plan has loaded. */
export function useViewed(
  screen: Exclude<Viewed["screen"], "root">,
  plan: CoveragePlan | null,
) {
  const headline = plan ? headlineState(plan).kind : null;
  const state: Viewed["state"] | null = !plan
    ? null
    : plan.health !== "ok"
      ? "couldntConfirm"
      : headline !== "totals"
        ? headline
        : plan.prices.length > 0
          ? "totalsAndPrices"
          : "totalsOnly";
  useEffect(() => {
    if (state) {
      analyticsService.trackEvent("CoverageScreenViewed", { screen, state });
    }
  }, [screen, state]);
}
